import { Icon } from '@/shared/ui/Icon'
import { useReferenceSelection } from './ReferenceSelectionProvider'

interface Props {
  onOpen?: () => void
  /** Render as a clickable chip when true (default); as plain text otherwise. */
  interactive?: boolean
}

/**
 * Compact pill summarising the reference-document selection. Sits next to
 * ``ActiveScopeBadge`` in the composer footer so the user can see at a glance
 * how many references will accompany the next question.
 */
export function ReferenceCountBadge({ onOpen, interactive = true }: Props) {
  const { selectedIds } = useReferenceSelection()
  const count = selectedIds.length
  const hasAny = count > 0

  const className =
    'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11.5px] font-medium transition-[background-color,border-color,color] duration-150 ease-smooth ' +
    (hasAny
      ? 'border-violet/40 bg-violet/[0.10] text-text'
      : 'border-white/10 bg-white/[0.03] text-text-mute')

  const label = hasAny
    ? `Referências: ${count} ${count === 1 ? 'selecionada' : 'selecionadas'}`
    : 'Sem referências'

  const content = (
    <>
      <Icon name="book" size={12} />
      <span className="max-w-[240px] truncate">{label}</span>
    </>
  )

  if (!interactive || !onOpen) {
    return <span className={className}>{content}</span>
  }
  return (
    <button
      type="button"
      onClick={onOpen}
      className={className + ' hover:border-violet/60 hover:bg-violet/[0.16] hover:text-text'}
      title="Selecionar referências para esta consulta"
    >
      {content}
    </button>
  )
}
